import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

/**
 * Constructor.io Global Config Initializer
 * Sets window.cnstrc with userId for behavioral tracking.
 * Constructor's script polls window.cnstrc.userId for up to 10 seconds after init.
 * For guest users, userId is left undefined — Constructor falls back to anonymous client_id.
 */
const initConstructorIO = (indexKey) => {
    if (__SERVER__ || window.cnstrc) return;

    const userState = LocalStorage.getData('DP_USER_STATE');
    const isLoggedIn = userState && userState !== '0';

    window.cnstrc = {
        indexKey,
    };

    if (isLoggedIn) {
        window.cnstrc.userId = LocalStorage.getData('ACCOUNT_ID');
    }
};

export const updateConstructorIOUserId = (clear) => {
    if (__SERVER__ || !window.cnstrc) return;
    if (clear) {
        delete window.cnstrc.userId;
        return;
    }
    const userState = LocalStorage.getData('DP_USER_STATE');
    if (userState && userState !== '0') {
        window.cnstrc.userId = LocalStorage.getData('ACCOUNT_ID');
    }
};

export default initConstructorIO;
